import Service from '../../services'

// initial state
const state = {

    allDataTopic: []

};


// getters
const getters = {

};


// actions
const actions = {

    onGetAllDataTopic({ commit }) {
        return Service.overview.getAllDataTopic().then((res) => {
            commit('setAllDataTopic', res);
        })
    },

};


// mutations
const mutations = {

    setAllDataTopic(state, data) {
        state.allDataTopic = data;
    }

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
